import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import SafetyPlanForm from "./SafetyPlanForm";
import { createSafetyPlan } from "../../../../store/slices/safetyPlansSlice";

const AddSafetyPlan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({
        caseId: caseId || null,
        patientId: patientId || null,
        warningSigns: "",
        internalCoping: "",
        socialDistractions: [],
        peopleHelp: "",
        professionals: "",
        safeEnvironment: "",
        reasonLiving: "",
    });

    const handleChange = (e, arrayName, index, field) => {
        if (arrayName) {
            const newArray = [...formData[arrayName]];
            newArray[index][field] = e.target.value;
            setFormData({ ...formData, [arrayName]: newArray });
        } else {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        }
    };

    const addWarningSign = (arrayName) => {
        setFormData({
            ...formData,
            [arrayName]: [...(formData[arrayName] || []), { name: "", contact: "" }],
        });
    };

    const removeWarningSign = (arrayName, index) => {
        setFormData({
            ...formData,
            [arrayName]: formData[arrayName].filter((_, i) => i !== index),
        });
    };

    const snakeCaseKeys = (obj) => {
        if (Array.isArray(obj)) return obj.map(snakeCaseKeys);
        if (obj !== null && typeof obj === "object") {
            return Object.fromEntries(
                Object.entries(obj).map(([k, v]) => [
                    k.replace(/([A-Z])/g, "_$1").toLowerCase(),
                    snakeCaseKeys(v),
                ])
            );
        }
        return obj;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Convert camelCase to snake_case for backend
            const payload = snakeCaseKeys({
                patient_id: formData.patientId,
                case_id: formData.caseId,
                warning_signs: formData.warningSigns,
                internal_coping: formData.internalCoping,
                social_distractions: formData.socialDistractions.map((sd) => ({
                    name: sd.name,
                    contact: sd.contact,
                })),
                people_help: formData.peopleHelp,
                professionals: formData.professionals,
                safe_environment: formData.safeEnvironment,
                reason_living: formData.reasonLiving,
            });

            const res = await dispatch(createSafetyPlan(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "Safety Plan has been created successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/residential/optional/safety-plan/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (err) {
            Swal.fire("Error!", err || "Failed to create Safety Plan", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <SafetyPlanForm
                                formData={formData}
                                handleChange={handleChange}
                                addWarningSign={addWarningSign}
                                removeWarningSign={removeWarningSign}
                            />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-save-2-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddSafetyPlan;
